export class ProgressUploader {
  static async uploadOctetStream (url: string, data: any, progressCallback: (this: XMLHttpRequestUpload, ev: ProgressEvent<XMLHttpRequestEventTarget>) => any): Promise<ProgressEvent<XMLHttpRequestEventTarget>> {
    return new Promise((resolve) => {
      const xhr = new XMLHttpRequest()
      xhr.open('POST', url, true)
      xhr.setRequestHeader('Content-Type', 'application/octet-stream')
      xhr.addEventListener('load', (e) => { resolve(e) })
      xhr.upload.addEventListener('progress', progressCallback)
      xhr.send(data)
    })
  }
}
